import { useArtifactViewCtx } from "@/components/artifacts/view/ArtifactViewContext.tsx";
import { firePickerDone } from "@/components/connectors/slack/firePickerDone.ts";
import { SlackChannelPickerForm } from "@/components/connectors/slack/SlackChannelPickerForm.tsx";
import { artifactQueries } from "@/hooks/artifactQueries.ts";
import * as Sentry from "@sentry/react";
import { useQueryClient } from "@tanstack/react-query";

/**
 * The Slack channels card on the canvas. Same form as the omnibox card; its
 * actions come from the artifact the canvas loaded (fetched if it isn't
 * cached), so adding okthx finishes the card through the same Done its footer
 * offers.
 */
export const SlackChannelsPickerBody = ({ teamId }: { teamId: string }) => {
  const { threadId, messageId, artifactId, onRequestClose } = useArtifactViewCtx();
  const queryClient = useQueryClient();

  const finish = async () => {
    const artifact = await queryClient
      .ensureQueryData(artifactQueries.detail(threadId, messageId, artifactId))
      .catch((error: unknown) => {
        Sentry.captureException(error);
        return undefined;
      });
    await firePickerDone(artifact && "actions" in artifact ? artifact.actions : undefined);
    onRequestClose?.();
  };

  return <SlackChannelPickerForm teamId={teamId} onJoined={() => void finish()} />;
};
